import React, { useEffect, useState, useRef, useLayoutEffect } from 'react'
import { CSSTransition } from 'react-transition-group'
import { useInView } from 'react-intersection-observer'

import { useAdStat } from 'Components/ad'
import applyHttpsImage from 'lib/apply-https-img'
import { sendTeaAdEvent, sendAdMonitor } from 'lib/tea-analyze'

import Label from './label'
import { SkyFallBannerAd } from './interface'
const timeout = 400

// 天幕广告
export default function TianmuAd({ data }: { data: SkyFallBannerAd }) {
  const [showBig, setShowBig] = useState(false)
  const [showSmall, setShowSmall] = useState(false)
  // 是否展示小图上的关闭按钮
  // const [showButton, setShowButton] = useState(false)
  const timer = useRef<number>()
  function closeBig() {
    timer.current = window.setTimeout(() => {
      setShowBig(false)
      setShowSmall(true)
    }, 5000)
  }
  useEffect(() => {
    sendTeaAdEvent('ad_send_float_curtain', {
      ad_material_id: data.materiel_str,
      ad_target_url: data.web_url,
      log_extra: data.log_extra,
      ad_id: data.id_str,
      ad_req_id: JSON.parse(data.log_extra).req_id,
    })
  }, [data.id_str, data.log_extra, data.materiel_str, data.web_url])
  useEffect(() => {
    let showed = false
    // 每两次刷新首页，只在第一次展现天幕广告
    try {
      showed = !!localStorage.getItem('tianmu_ad_showed')
      localStorage.setItem('tianmu_ad_showed', '1')
    } catch (err) {}
    if (showed) {
      try {
        localStorage.removeItem('tianmu_ad_showed')
      } catch (err) {}
      return
    }

    setShowBig(true)
    closeBig()
    return () => {
      clearTimeout(timer.current)
    }
  }, [data.image_big.url])

  if (!data) return null
  return (
    <>
      <CSSTransition
        in={showBig}
        timeout={timeout}
        mountOnEnter
        unmountOnExit
        classNames="big"
        onExited={() => {
          clearTimeout(timer.current)
          setShowSmall(true)
        }}
      >
        <BigImage
          data={data}
          onClose={() => {
            setShowBig(false)
            setShowSmall(true)
          }}
        />
      </CSSTransition>
      <CSSTransition
        in={showSmall}
        unmountOnExit
        timeout={200}
        classNames="small"
      >
        <SmallImage
          data={data}
          onClickReplay={() => {
            setShowBig(true)
            closeBig()
            setShowSmall(false)
          }}
          onClose={() => {
            setShowSmall(false)
          }}
        />
      </CSSTransition>

      <style jsx global>
        {`
          .big-enter {
            opacity: 0;
            transform: translate3d(0, -100%, 0);
          }
          .big-enter-active {
            opacity: 1;
            transform: translate3d(0, 0, 0);
            transition: opacity ${timeout}ms, transform ${timeout}ms;
          }
          .big-exit {
            opacity: 1;
            transform: translate3d(0, 0, 0);
          }
          .big-exit-active {
            opacity: 0;
            transform: translate3d(0, -100%, 0);
            transition: opacity ${timeout}ms, transform ${timeout}ms;
          }
        `}
      </style>
    </>
  )
}

interface IBigImageProps {
  data: SkyFallBannerAd
  onClose(): void
}

function BigImage({ data, onClose }: IBigImageProps) {
  const { ref, handleClick } = useAdStat(
    {
      send: '',
      show: '',
      click: 'ad_click_float_curtain',
    },
    data,
    undefined,
    4000
  )
  const [ref2, inView] = useInView({
    threshold: 0,
  })
  const adData = {
    ad_material_id: data.materiel_str,
    ad_target_url: data.web_url,
    log_extra: data.log_extra,
    ad_id: data.id_str,
    ad_req_id: JSON.parse(data.log_extra).req_id,
  }
  useEffect(() => {
    if (inView) {
      sendTeaAdEvent('ad_show_float_curtain', {
        ad_material_id: data.materiel_str,
        ad_target_url: data.web_url,
        log_extra: data.log_extra,
        ad_id: data.id_str,
        ad_req_id: JSON.parse(data.log_extra).req_id,
      })
      if (data.click_track_url_list) {
        data.click_track_url_list.forEach(url => {
          sendAdMonitor({
            url,
            requestId: data.ad_log_id,
            eventId: 'show',
          })
        })
      }
    }
  }, [inView])
  return (
    <div
      className="big"
      ref={ref}
      onClick={() => {
        handleClick()
        setTimeout(() => window.open(data.web_url, '_blank'), 50)
      }}
    >
      <img src={data.image_big.url} className="tianmu_image" ref={ref2} />
      <span
        role="button"
        className="close"
        onClick={e => {
          e.stopPropagation()
          sendTeaAdEvent('ad_dislike_float_curtain', adData)
          onClose()
        }}
      >
        <i className="icon-dislike-ic" />
      </span>
      <Label text={data.label} />
      <style jsx>
        {`
          .big {
            position: absolute;
            top: -130px;
            width: 1196px;
            height: 380px;
            z-index: 10;
          }
          img {
            vertical-align: middle;
            width: 100%;
            height: 100%;
          }
          .close {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            right: 8px;
            top: 8px;
            color: #fff;
            width: 18px;
            height: 18px;
            border-radius: 9px;
            background: rgba(0, 0, 0, 0.3);
          }
        `}
      </style>
    </div>
  )
}
interface ISmallImageProps {
  data: SkyFallBannerAd
  onClickReplay(): void
  onClose(): void
}
function SmallImage({ data, onClickReplay, onClose }: ISmallImageProps) {
  const [ref1, inView] = useInView({
    threshold: 0,
  })

  const sendStatRef = useRef<number>()
  useLayoutEffect(() => {
    // 2s内重复出现，不上报
    if (sendStatRef.current) {
      return
    }

    if (inView) {
      sendTeaAdEvent('ad_show_float_curtain', {
        ad_material_id: data.materiel_str,
        ad_target_url: data.web_url,
        log_extra: data.log_extra,
        ad_id: data.id_str,
        ad_req_id: JSON.parse(data.log_extra).req_id,
      })
      if (data.click_track_url_list) {
        data.click_track_url_list.forEach(url => {
          sendAdMonitor({
            url,
            requestId: data.ad_log_id,
            eventId: 'show',
          })
        })
      }
      sendStatRef.current = window.setTimeout(() => {
        sendStatRef.current = 0
      }, 2000)
    }
  }, [data, inView])

  const { ref, handleClick } = useAdStat(
    {
      send: '',
      show: '',
      click: 'ad_click_float_curtain',
    },
    data,
    undefined,
    4000
  )

  return (
    <div className="small" ref={ref}>
      <a
        ref={ref1}
        onClick={() => {
          handleClick()
          setTimeout(() => {
            window.open(data.web_url, '_blank')
          }, 50)
        }}
      />
      <div>
        <span
          role="button"
          onClick={e => {
            // 阻止事件冒泡
            e.stopPropagation()
            onClickReplay()
          }}
        >
          重播
        </span>
        <span
          role="button"
          onClick={e => {
            // 阻止事件冒泡
            e.stopPropagation()
            onClose()
          }}
        >
          关闭
        </span>
      </div>
      <style jsx>
        {`
          .small {
            position: absolute;
            right: -126px;
            top: 0;
            border-radius: 2px;
            overflow: hidden;
          }
          .small a {
            display: block;
            width: 110px;
            height: 90px;
            background: url(${applyHttpsImage(data.image_icon.url)}) 0 0
              no-repeat;
            background-size: 100% 100%;
          }
          .small div {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            height: 20px;
            background: rgba(0, 0, 0, 0.6);
          }
          .small span {
            width: 50%;
            font-size: 10px;
            line-height: 20px;
            text-align: center;
            cursor: pointer;
            color: #fff;
          }
          img {
            width: 100%;
          }
          .button {
            position: absolute;
            top: 8px;
            width: 18px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            color: #fff;
            cursor: pointer;
          }
        `}
      </style>
    </div>
  )
}
